import React from 'react';

function Logo(props) {
  return <img alt="Logo" src="/static/pt_logo2.svg" {...props} />;
}

export default Logo;
